/**
 * Collection SEO Content — Read more / read less truncation
 * Truncates long SEO content blocks to MAX_LINES with a toggle button.
 */
(function () {
  var MAX_LINES = 3;
  var bodyEl = document.querySelector('.collection-seo-content__body');
  if (!bodyEl) return;

  var originalHTML = bodyEl.innerHTML;

  function getMaxHeight() {
    var computed = window.getComputedStyle(bodyEl);
    var lh = parseFloat(computed.lineHeight);
    if (isNaN(lh)) lh = parseFloat(computed.fontSize) * 1.3;
    return Math.ceil(lh * MAX_LINES);
  }

  function needsTruncation() {
    return bodyEl.scrollHeight > getMaxHeight() + 2;
  }

  function createToggle(label, onClick) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'collection-seo-content__toggle';
    btn.textContent = label;
    btn.addEventListener('click', onClick);
    return btn;
  }

  /**
   * Build truncated DOM in a hidden measurer.
   * Walk text nodes in reverse, binary-search the last one that fits,
   * remove everything after it, then return the measurer element
   * so we can move its children into the real DOM (preserving links).
   */
  function buildTruncatedFragment(maxHeight) {
    var measurer = document.createElement('div');
    var cs = window.getComputedStyle(bodyEl);
    measurer.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;';
    measurer.style.width = bodyEl.offsetWidth + 'px';
    measurer.style.font = cs.font;
    measurer.style.letterSpacing = cs.letterSpacing;
    measurer.style.lineHeight = cs.lineHeight;
    measurer.innerHTML = originalHTML;
    document.body.appendChild(measurer);

    // Collect all text nodes in DOM order
    var textNodes = [];
    var walker = document.createTreeWalker(measurer, NodeFilter.SHOW_TEXT, null, false);
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    var suffix = '\u2026read more';

    // Work backwards through text nodes
    for (var i = textNodes.length - 1; i >= 0; i--) {
      var node = textNodes[i];
      var origText = node.textContent;

      // First: blank all text nodes after this one
      for (var j = i + 1; j < textNodes.length; j++) {
        textNodes[j].textContent = '';
      }

      // Binary search this node's text length
      var low = 0;
      var high = origText.length;

      // Insert suffix span inline right after the text node
      // (inside the same parent, e.g. inside <p> or <a>)
      var suffixSpan = document.createElement('span');
      suffixSpan.style.cssText = 'display:inline;';
      suffixSpan.textContent = suffix;
      node.parentNode.insertBefore(suffixSpan, node.nextSibling);

      while (low < high) {
        var mid = Math.ceil((low + high) / 2);
        node.textContent = origText.substring(0, mid);
        if (measurer.scrollHeight <= maxHeight + 2) {
          low = mid;
        } else {
          high = mid - 1;
        }
      }

      suffixSpan.remove();

      if (low > 0) {
        node.textContent = origText.substring(0, low);

        // Remove all empty elements after the cut
        // Walk up from this node, removing subsequent empty siblings
        removeNodesAfter(node, measurer);

        document.body.removeChild(measurer);
        return measurer;
      }

      // Whole node doesn't fit, blank it and try previous
      node.textContent = '';
    }

    // Fallback
    document.body.removeChild(measurer);
    measurer.innerHTML = originalHTML;
    return measurer;
  }

  /**
   * Remove all DOM nodes that come after `node` within `root`,
   * walking up through parents. Also removes emptied parent elements.
   */
  function removeNodesAfter(node, root) {
    var current = node;
    while (current && current !== root) {
      // Remove all next siblings of current
      while (current.nextSibling) {
        current.parentNode.removeChild(current.nextSibling);
      }
      current = current.parentNode;
    }
  }

  /**
   * Find the last text node in an element.
   */
  function getLastTextNode(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var last = null;
    while (walker.nextNode()) {
      last = walker.currentNode;
    }
    return last;
  }

  function render(expanded) {
    if (expanded) {
      // Show full original HTML + inline "read less"
      bodyEl.innerHTML = originalHTML;
      var lastText = getLastTextNode(bodyEl);
      var appendTo = lastText ? lastText.parentNode : (bodyEl.lastElementChild || bodyEl);
      appendTo.appendChild(document.createTextNode(' '));
      appendTo.appendChild(createToggle('read less', function () {
        render(false);
      }));
    } else {
      // Build truncated content preserving HTML
      var fragment = buildTruncatedFragment(getMaxHeight());

      bodyEl.innerHTML = '';
      while (fragment.firstChild) {
        bodyEl.appendChild(fragment.firstChild);
      }

      // Append "…read more" after the last text node
      var lastText = getLastTextNode(bodyEl);
      var appendTo = lastText ? lastText.parentNode : (bodyEl.lastElementChild || bodyEl);
      appendTo.appendChild(document.createTextNode('\u2026'));
      appendTo.appendChild(createToggle('read more', function () {
        render(true);
      }));
    }
  }

  // Check on init
  if (needsTruncation()) {
    render(false);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      bodyEl.innerHTML = originalHTML;
      if (needsTruncation()) {
        render(false);
      }
    }, 150);
  });
})();
